import React from 'react';
import { Link, Typography } from '@one-thd/sui-atomic-components';
import { CardType } from '../../../constants/payments';
import { PRO_XTRA_PERKS_PATH } from '../../../constants/links';
export const EMPTY_PAYMENTS_MESSAGES = {
    [CardType.CREDIT_CARD]: {
        title: "You haven't saved any credit cards.",
        message: 'Add a credit card for quick and easy checkout the next time you shop.',
        dataTestId: 'no-credit-card-saved-msg',
    },
    [CardType.PAYPAL_ACCOUNT]: {
        title: "You haven't saved any PayPal accounts.",
        message: 'Add a PayPal account for quick and easy checkout the next time you shop.',
    },
    [CardType.PRO_XTRA_DOLLARS]: {
        title: "You haven't saved any Pro Xtra Dollars accounts.",
        message: (React.createElement(React.Fragment, null,
            "Shop online with your Pro Xtra account or scan your Virtual ID at in-store checkout to earn Pro Xtra Dollars. Visit",
            ' ',
            React.createElement(Link, { underline: "always", href: PRO_XTRA_PERKS_PATH }, "Pro Xtra Perks"),
            ' ',
            "to track your earning progress.")),
    },
    [CardType.GIFT_CARD]: {
        title: "You haven't saved any gift cards.",
        message: 'Add a gift card to track your in-store purchase history.',
    },
    [CardType.CHECKING_ACCOUNT]: {
        title: "You haven't saved any checking accounts.",
        message: 'Add a checking account to track your in-store purchase history.',
    },
    [CardType.KEY_TAG]: {
        title: "You haven't saved any Keytags.",
        message: 'Add a Keytag to track your in-store purchase history.',
    },
    // TODO: update the title and message when available
    [CardType.PRO_HOUSE_ACCOUNT]: {
        title: "You haven't saved any Pro Trade Credit.",
        message: 'Add a Pro Trade Credit to track your in-store purchase history.',
    },
};
export const NoPaymentCardsMessage = ({ tenderType, }) => {
    const tenderMessage = EMPTY_PAYMENTS_MESSAGES[tenderType];
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-between sui-gap-4" },
        React.createElement(Typography, { variant: "body-base", weight: "bold", "data-tesid": tenderMessage.dataTestId }, tenderMessage.title),
        React.createElement(Typography, { variant: "body-base" }, tenderMessage.message)));
};
